import { render } from "./DraftMessages.vue?vue&type=template&id=c073cee4&scoped=true"
import script from "./DraftMessages.vue?vue&type=script&lang=js"
export * from "./DraftMessages.vue?vue&type=script&lang=js"

import "./DraftMessages.vue?vue&type=style&index=0&id=c073cee4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c073cee4"]])

export default __exports__